import {
    useMutation,
    UseMutationResult,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'
import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'

import simpleApi from 'app/services/simpleApi'
import requests from 'app/requests/Quote/Quote.requests'

type RequestParams = {
    quoteId: number,
    description: string,
    documentId: number,
}

const useQuotePdfDescriptionEdit = (
    onSuccess: () => void,
): UseMutationResult<unknown, unknown, RequestParams> => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessRemoveInvoice,
        onError,
    } = useHandleStatusRequest({
        id: 'QuotePdf',
        title: 'Document Description has been updated',
        onSuccess,
    })

    return useMutation({
        mutationFn: ({
            quoteId,
            description,
            documentId,
        }: RequestParams) => {
            return simpleApi({
                ...requests.updatePdfQuoteDescription({
                    quoteId,
                    description,
                    documentId,
                }),
                token,
            })
        },
        onSuccess: onSuccessRemoveInvoice,
        onError,
    })
}

export default useQuotePdfDescriptionEdit
